import { create } from 'zustand';
import type { Identity } from '@/api/schemas';

type AuthState = {
  user: Identity | null;
  status: 'idle' | 'loading' | 'authenticated' | 'unauthenticated';
  setUser: (u: Identity | null) => void;
  setStatus: (s: AuthState['status']) => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  setUser: (user) =>
    set({ user, status: user ? 'authenticated' : 'unauthenticated' }),
  setStatus: (status) => set({ status }),
}));
